<template>
  <div class="catalog-content__card-favourites" :key="update">
    <input type="checkbox" :id="'catalog__card-favourites--' + productId" @change="addToFavs" :checked="activeHeart"/>
    <label
        :for="'catalog__card-favourites--' + productId"
        name="catalog__card-favourites"
    >
    </label>
  </div>
</template>

<script>
import {useToast} from "vue-toastification";
import {useFavsStore} from "../store/favorites";

export default {
  name: "favoritesAddProductComponent",
  props: [
    'userId',
    'productId',
    'ip',
  ],
  data() {
    return {
      loading: true,
      toast: useToast(),
      favsStore: useFavsStore(),
      items: [],
      update: 0,
      productInFavs: false,
      activeElements: [],
      ufName: null
    }
  },
  computed: {
    activeHeart() {
      if (Object.keys(this.items).length !== 0) {
        return this.activeElements.indexOf(this.productId) !== -1;
      } else {
        return false;
      }
    },
  },
  methods: {
    addToFavs(el) {
      this.favsStore.setFavs(this.productId, this.ufName, el.target.checked);
      this.inFavs();
    },
    async inFavs() {
      await this.favsStore.inFavs(this.ufName).then(() => {
        this.items = this.favsStore.favsData;
        this.getActiveElements();
      })
    },
    getActiveElements() {
      if (Object.keys(this.items).length !== 0) {
        let tmpActiveElements = [];
        for (var key in this.items) {
          tmpActiveElements.push(this.items[key].ID);
        }
        this.activeElements = tmpActiveElements;
      }
    }
  },
  mounted() {
    this.ufName = this.userId;

    // if (parseInt(this.userId) === 0) {
    //   this.ufName = 0;
    // }

    this.inFavs();
  },
}
</script>
